// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3g-rI","checkboxCol":"Table_checkboxCol__3ThkE","emailCol":"Table_emailCol__3NB4x","actionCol":"Table_actionCol__3yHBn"};